module.exports = __webpack_public_path__ + "img/5.244cb12d.png";